<template>
  <v-dialog v-model="dialog" @click.esc="dialog=false" :fullscreen="$vuetify.breakpoint.mdAndDown">
    <template v-slot:activator="{on}">
      <v-card
          height="100%"
          class="mx-auto"
          hover
          v-on="on"
      >
        <v-container class="fill-height pa-0">
          <v-row>
            <v-col class="py-0">
              <v-img v-if="poster.thumbnail" :src="poster.thumbnail"/>
              <pdf v-else :src="poster.pdf" style="position: relative">
              </pdf>
            </v-col>
          </v-row>
            <v-row>
              <v-col class="py-0">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>{{ poster.title }}</v-list-item-title>
                    <v-list-item-subtitle v-if="poster.author">
                      {{ poster.author }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
            </v-row>
        </v-container>
      </v-card>
    </template>
    <v-card tile>
      <v-toolbar
          color="grey lighten-4"
      >
        <v-toolbar-title class="primary--text">
          {{ poster.title }}
        </v-toolbar-title>
        <v-btn :href="poster.pdf" download target="_blank" icon class="ml-3" color="primary">
          <v-icon>mdi-content-save-outline</v-icon>
        </v-btn>
        <v-spacer></v-spacer>

        <v-btn @click="dialog=false" color="primary" icon>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-list-item v-if="poster.author">
        <v-list-item-content>
          <v-list-item-title>
            {{ poster.author }}
          </v-list-item-title>
          <v-list-item-subtitle v-if="poster.email">
            <a :href="`mailto:${poster.email}`">{{ poster.email }}</a>
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <template v-if="dialog">
        <pdf
            v-for="i in numPages"
            :key="i"
            :src="src"
            :page="i"
            style="position: relative"
        ></pdf>
      </template>
    </v-card>
  </v-dialog>
</template>

<script>
import pdf from 'vue-pdf';


export default {
  name: 'Poster',
  components: {
    pdf,
  },
  props: {
    poster: {
      type: Object,
      default: () => ( {} ),
    },
  },
  data ()
  {
    return {
      src: null,
      dialog: false,
      numPages: undefined
    };
  },
  watch: {
    dialog(isOpen) {
      if(isOpen && !this.src) {
        this.src = pdf.createLoadingTask(this.poster.pdf)

        this.src.promise.then(pdf => {
          this.numPages = pdf.numPages;
        });
      }
    }
  },
};
</script>

<style scoped>

</style>